import { Button } from '@mantine/core';
import { IconArrowLeft, IconMapSearch } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/ui/StateViews';
import { PageHeader } from '@/components/ui/PageHeader';

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Страница не найдена" />
      <EmptyState
        icon={<IconMapSearch size={28} stroke={1.5} />}
        title="Такого раздела нет"
        description="Проверьте адрес или вернитесь на главную."
        action={
          <Button component={Link} to="/dashboard" leftSection={<IconArrowLeft size={15} />}>
            На главную
          </Button>
        }
      />
    </>
  );
}
